"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCollector() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="150579" id="defining-the-groove" className="dark bg-[#3B2F2F] text-[#F6F3EE] w-full min-h-screen flex flex-col lg:flex-row">
      {}
      <div className="relative w-full lg:w-1/2 h-[50vh] lg:h-auto overflow-hidden bg-[#2D2424]">
        <img src="https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture.jpg" alt="Synergy Sound lead singers in Los Angeles" className="absolute inset-0 w-full h-full object-cover grayscale contrast-150 brightness-90 opacity-90 transition-all duration-700 hover:sepia hover:grayscale-0" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-[#3B2F2F] via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-[#3B2F2F] opacity-95" />
      </div>

      {}
      <div className="w-full flex flex-col p-8 relative z-10 !items-start !justify-start lg:w-1/2 md:p-16 lg:p-24 xl:p-32">
        <div ref={textRef} className={`max-w-xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-sm font-mono tracking-[0.3em] text-[#C8A96A] uppercase mb-8 opacity-90">
            The Essence of Soul
          </h2>
          
          <p className="text-lg md:text-xl lg:text-2xl leading-relaxed text-[#F6F3EE]/90 font-sans font-light first-letter:text-7xl md:first-letter:text-8xl lg:first-letter:text-9xl first-letter:font-serif first-letter:text-[#C8A96A] first-letter:float-left first-letter:mr-6 first-letter:mt-2 first-letter:leading-none">
            Born in the soul-drenched heart of Los Angeles, Synergy Sound is more than a band—it’s a rhythmic journey through the golden eras of R&B and timeless classics. We don't just perform; we curate an atmosphere of high-end elegance, blending technical mastery with the raw emotion of a midnight lounge. From the sun-kissed hills to the city’s most exclusive galas, our groove is the pulse of every unforgettable celebration.
          </p>
        </div>
      </div>
    </section>;
}